export default __webpack_public_path__ + "assets/bigsound_logo_white.7b6ae168.png";